import React, { useState } from "react";
import "./PasswordReset.css";
import api from '../../services/auth';

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' ou 'error'
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setMessageType("");
    try {
      const res = await api.post('/password-reset/request-reset', { email });
      const data = res.data;
      if (res.status === 200) {
        setMessage("Un email de réinitialisation a été envoyé à votre adresse si elle existe dans notre base. Pensez à vérifier vos spams.");
        setMessageType("success");
      } else {
        let msg = data.detail || data.error || "Une erreur est survenue. Merci de réessayer.";
        if (msg.toLowerCase().includes("introuvable") || msg.toLowerCase().includes("not found")) {
          msg = "Aucun utilisateur trouvé avec cet email.";
        } else if (msg.toLowerCase().includes("smtp") || msg.toLowerCase().includes("connexion")) {
          msg = "Impossible d'envoyer l'email. Merci de contacter l'administrateur.";
        }
        setMessage(msg);
        setMessageType("error");
      }
    } catch (err) {
      setMessage("Erreur réseau ou serveur. Merci de réessayer.");
      setMessageType("error");
    }
    setLoading(false);
  };

  return (
    <div className="reset-container">
      <h2>Mot de passe oublié</h2>
      <div className="subtitle">Saisissez votre adresse email pour recevoir un lien de réinitialisation.</div>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Votre adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading && <span className="spinner" />} Envoyer le lien
        </button>
      </form>
      {message && (
        <div className={`message ${messageType}`}>{messageType === 'error' ? '❌' : '✅'} {message}</div>
      )}
    </div>
  );
}


export default ForgotPassword;
